export function formatNumber(value?: number | null, specifyFractionDigits = false) {
  const formatOptions: Intl.NumberFormatOptions = specifyFractionDigits
    ? { minimumFractionDigits: 2, maximumFractionDigits: 2 }
    : {};

  return value?.toLocaleString('da-DK', formatOptions) ?? ''
}

export function formatMoney(value?: number | null | undefined) {
  if (value === null || value === undefined) {
    return ''
  }

  return `kr. ${value.toLocaleString('da-DK')}`;
}

export async function waitUntil(
  conditionCheck: () => boolean,
  errorMessage = "function did not load within the timeout period",
  timeout = 5000,
  interval = 100) {
  const start = Date.now();
  return new Promise<void>((resolve, reject) => {
    const check = () => {
      if (conditionCheck()) {
        resolve();
      } else if (Date.now() - start > timeout) {
        reject(new Error(errorMessage));
      } else {
        setTimeout(check, interval);
      }
    };
    check();
  });
}